import React from "react";

const Privacy = () => {
  return (
    <main className="legal">
      <header className="legalHead">
        <h1>Privacy Policy</h1>
        <p className="legalLead">
          This website does not collect, store or process any personal data.
        </p>
      </header>
      <section className="legalSection">
        <h2>Cookies and local storage</h2>
        <p>
          This website does not use cookies. When you switch between light and
          dark mode, your choice is saved in your browser&rsquo;s local storage
          so it is remembered on your next visit. This setting stays on your
          device, is never sent to the server and can be removed at any time by
          clearing your browser data.
        </p>
      </section>
      <section className="legalSection">
        <h2>Server log files</h2>
        <p>
          For technical reasons, the web server records the browser, operating
          system, referrer URL and date and time of each access.
        </p>
        <p>
          IP addresses are not stored: logging is configured so that they are
          never written to the log files.{" "}
          <a
            className="legalLink"
            href="https://schneide.blog/2019/09/24/how-to-disable-ip-address-logging-for-apache-web-server-and-tomcat/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more about the technical implementation
          </a>
        </p>
      </section>
      <section className="legalSection">
        <h2>Fonts</h2>
        <p>
          The fonts used on this website, Lato and Merriweather, are hosted on
          this server. No data, including your IP address, is transferred to
          third-party font providers.
        </p>
      </section>
      <section className="legalSection">
        <h2>Third-party services and external links</h2>
        <p>
          This website does not embed third-party content and does not use
          analytics or tracking of any kind. It does link to external websites,
          which are subject to their own privacy policies. I accept no
          liability for their content.
        </p>
        <p>
          All external links were last reviewed for availability and safety in
          September 2026.
        </p>
      </section>
      <section className="legalSection">
        <h2>Contact</h2>
        <p>
          For any questions about privacy, please contact{" "}
          <a className="legalLink" href="mailto:office@matteorosoli.at">
            office@matteorosoli.at
          </a>
          .
        </p>
      </section>
    </main>
  );
};

export default Privacy;
